import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useToast } from "../../Providers/ToastProvider";
import SocketContext from "../../socket/SocketProvider/SocketProvider";

type ChatFileSelectPopupProps = {
  onSendFile: (file: File) => void;
  onHide: () => void;
};

export function ChatFileSelectPopup({
  onSendFile,
  onHide,
}: ChatFileSelectPopupProps) {
  const fileInputRef = useRef(null);
  const { show } = useToast();
  const socket = useContext(SocketContext);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (socket) {
      socket.on("fileSent", () => {
        onHide();
        setLoading(false);
      });
      return () => {
        socket.off("fileSent");
      };
    }
  }, [socket]);

  const headerTemplate = (options: any) => {
    const { className, chooseButton } = options;

    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        {chooseButton}
      </div>
    );
  };

  const sendFile = () => {
    //@ts-ignore
    const files = fileInputRef.current.getFiles();
    onSendFile(files[0]);
    setLoading(true);
  };

  const handleFileSelect = (e: any) => {
    if (!e.files[0].type.startsWith("image/")) {
      (fileInputRef as any).current?.clear();
      show({
        severity: "error",
        detail:
          "Unsupported Attachment Type. Currently, only photo files (such as JPG, PNG) can be shared as attachments.",
      });
      return;
    }
  };

  const attachFilePopupFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-text p-button-secondary"
        onClick={onHide}
      />
      <Button
        label="Send"
        icon="pi pi-check"
        className="p-button-text p-button-primary"
        type="button"
        disabled={loading}
        onClick={sendFile}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={true}
      onHide={onHide}
      header="Select Image"
      footer={attachFilePopupFooter}
      style={{ minWidth: "500px" }}
    >
      <FileUpload
        ref={fileInputRef}
        accept="image/*"
        customUpload
        onSelect={handleFileSelect}
        headerTemplate={headerTemplate}
      />
    </Dialog>
  );
}
